import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Task } from '../../../../../data/tasks/task';
import { TasksService } from '../../../../../data/tasks/tasks.service';
import { TaskEditDialogComponent } from '../task-edit-dialog/task-edit-dialog.component';
import { ShortTask } from '../../../../../data/tasks/short-task';

@Component({
    selector: 'app-tasks-list-dialog',
    templateUrl: './tasks-list-dialog.component.html',
    styleUrls: ['./tasks-list-dialog.component.scss']
})
export class TasksListDialogComponent implements OnInit {
    tasksLoading: boolean;

    tasks: ShortTask[];

    constructor(
        protected dialog: MatDialog,
        protected tasksService: TasksService,
        protected dialogRef: MatDialogRef<TasksListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            entityId: number,
            clazz: string
        }
    ) { }

    ngOnInit(): void {
        this.getTasks();
    }

    getTasks() {
        this.tasksLoading = true;
        this.tasksService.getTasksByEntityId(this.data.clazz, this.data.entityId).subscribe(tasks => {
            this.tasks = tasks.map(task => {
                const tempresult = {
                    id: task.id,
                    assignedUserName: task.assignedUser.name,
                    authorName: task.author.name,
                    completed: task.completed,
                    text: task.text,
                    totalComments: task.totalComments,
                    projectId: task.project ? task.project.id : null,
                    projectName: task.project ? task.project.name : null,
                    deadline: task.deadline,
          photoIds: task.photoIds,
          hasFiles: task.hasFiles
                } as ShortTask
                return tempresult;
            });

            this.tasksLoading = false;
        })
    }

    editTask(task: ShortTask) {
        let panelClass = 'task-edit-dialog';
        if (task.checkItems) {
            panelClass += ' checkitems-exists'
        }

        const dialogRef = this.dialog.open(TaskEditDialogComponent, {
            data: {
                task,
                buttonLabel: 'Save'
            },
            panelClass,
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (typeof result !== 'undefined') {
                if (result === 'DELETE') {
                    const index = this.tasks.indexOf(task, 0);
                    if (index > -1) {
                        this.tasks.splice(index, 1);
                    }
                }
                else {
                    const tempTask = result as Task;
                    const ftask = this.tasks.find(ttask => ttask.id === result.id);

                    if (ftask) {
                        ftask.text = tempTask.text;
                        ftask.assignedUserName = tempTask.assignedUser.name;
                        ftask.projectId = tempTask.project ? tempTask.project.id : null;
                        ftask.projectName = tempTask.project ? tempTask.project.name : null;
                        ftask.deadline = tempTask.deadline;
                    }
                }
            }
        });
    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }
}
